export const projects = [
  {
    imgHero: 'image-manage-hero',
    title: 'Manage',
    infos: 
      'This project required me to build a fully responsive landing page to the designs provided. I used HTML5, along with CSS Grid and JavaScript for the areas that required interactivity, such as the testimonial slider.',
    type: 'Interaction Design / Front End Development',
    technos: ['HTML', 'JS', 'CSS'],
    description: 
      'This project was a front-end  challenge from Frontend Mentor. It’s a platform that enables you to practice building websites to a design and project brief. Each challenge includes mobile and desktop designs to show how the website should look at different screen sizes. Creating these projects has helped me refine my workflow and solve real-world coding problems. I’ve learned something new with each project, helping me to improve and adapt my style.',
    preview1: 'image-manage-preview-1',
    preview2 : 'image-manage-preview-2',
    previousProject: 'fylo',
    nextProject: 'bookmark',
  },
  {
    imgHero: 'image-bookmark-hero',
    title: 'BookMark',
    infos: 
      'This project required me to build a fully responsive landing page to the designs provided. I used HTML5, along with CSS Grid and JavaScript for the areas that required interactivity, such as the features section.',
    type: 'Interaction Design / Front End Development',
    technos: ['HTML', 'JS', 'CSS'],
    description: 
      'This project was a front-end  challenge from Frontend Mentor. It’s a platform that enables you to practice building websites to a design and project brief. Each challenge includes mobile and desktop designs to show how the website should look at different screen sizes. Creating these projects has helped me refine my workflow and solve real-world coding problems. I’ve learned something new with each project, helping me to improve and adapt my style.',
    preview1: 'image-bookmark-preview-1',
    preview2 : 'image-bookmark-preview-2',
    previousProject: 'manage',
    nextProject: 'insure',
  },
  {
    imgHero: 'image-insure-hero',
    title: 'Insure',
    infos: 
      'This was a small project which mostly consisted of HTML and CSS. I built a fully-responsive landing page. The only JavaScript this project required was to enable the toggling of the mobile navigation.',
    type: 'Interaction Design / Front End Development',
    technos: ['HTML', 'JS', 'CSS'],
    description: 
      'This project was a front-end  challenge from Frontend Mentor. It’s a platform that enables you to practice building websites to a design and project brief. Each challenge includes mobile and desktop designs to show how the website should look at different screen sizes. Creating these projects has helped me refine my workflow and solve real-world coding problems. I’ve learned something new with each project, helping me to improve and adapt my style.',
    preview1: 'image-insure-preview-1',
    preview2 : 'image-insure-preview-2',
    previousProject: 'bookmark',
    nextProject: 'fylo',
  },
  {
    imgHero: 'image-fylo-hero',
    title: 'Fylo',
    infos: 
      'This project was built in pure HTML and CSS. I had mobile and desktop designs to work to and built it so that it was fully-responsive. I took a mobile-first approach and used modern CSS like Flexbox and Grid for layout purposes.',
    type: 'Interaction Design / Front End Development',
    technos: ['HTML', 'CSS'],
    description: 
      'This project was a front-end  challenge from Frontend Mentor. It’s a platform that enables you to practice building websites to a design and project brief. Each challenge includes mobile and desktop designs to show how the website should look at different screen sizes. Creating these projects has helped me refine my workflow and solve real-world coding problems. I’ve learned something new with each project, helping me to improve and adapt my style.',
    preview1: 'image-fylo-preview-1',
    preview2 : 'image-fylo-preview-2',
    previousProject: 'insure',
    nextProject: 'manage',
  }
]